export default class ControlledArea {
  system;
  type;
  group;
  driveId;
  itemId;
  identifier;
  name;
  confidentialId;
  behavior;
  entity;

  constructor(apiControlledArea) {
    if (!apiControlledArea) return;

    this.system = apiControlledArea.system;
    this.type = apiControlledArea.type;
    this.group = apiControlledArea.group || apiControlledArea.groupName;
    this.driveId = apiControlledArea.driveId;
    this.itemId = apiControlledArea.itemId;
    this.identifier = apiControlledArea.identifier;
    this.name = apiControlledArea.name;
    this.confidentialId = apiControlledArea.confidentialId;
    this.behavior = apiControlledArea.behavior;
    this.entity = apiControlledArea.entity;
  }
}
